import { Col } from 'antd';

import { Title } from '@atom/typography/typography';
import { useMedia } from '@hook/style/use-media.hook';

import { DashboardCard } from '../dashboard.page-style';
import { useDashboardStart } from './dashboard-start.hook';
import { Steps } from './dashboard-start.style';

export const DashboardStart = () => {
  const step = useDashboardStart();
  const { isMobile } = useMedia();

  return step === 3 ? null : (
    <Col span={24}>
      <DashboardCard
        bordered={false}
        title={
          <Title level={isMobile ? 5 : 4} weight={500}>
            Get started
          </Title>
        }
      >
        <Steps
          current={step}
          items={[
            {
              description: 'Set up application',
            },
            {
              description: 'Enable integrations',
            },
            {
              description: 'Create consumer',
            },
            // {
            //   description: 'Connect integrators',
            // },
          ]}
        />
      </DashboardCard>
    </Col>
  );
};
